import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AgentsAlerts} from "../../../agents/services/agents-alerts.service";
import {DepotsDialogService} from "../../../depots/services/depots-dialogs-service.service";
import {DepotsService} from "../../../depots/services/depots-service.service";
import {DepotReferenceModel} from "../../../depots/angular/models/depot-reference.model";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {BranchModel} from "../../models/branch.model";

export class BranchesDepotsViewCtrl implements IController {

  branch: BranchModel;

  private canRemove: boolean;
  private depotsRef: any;
  private doReload = false;
  private queryString = undefined;
  private agentIdToAdd = undefined;
  private avoidIds = [];


  /* @ngInject */
  constructor(private depotsDialogService: DepotsDialogService, private depotsService: DepotsService,
              private IAMPermissions, private $depots, private agentsAlerts: AgentsAlerts,
              private $log, private confirmDialogService: ConfirmDialogService) {
  }

  $onInit() {
    this.canRemove = this.IAMPermissions.hasPermission('depots.update');
    this.depotsRef = this.$depots();
    this.depotsRef.$getAll({branchIds: [this.branch.id]})
      .then((agentIds) => {
        this.avoidIds = agentIds;
      })
  }

  // ******************************
  //        Public methods
  // ******************************

  submitQuery(query) {
    this.queryString = query;
  }

  onInviteDepot(event) {
    this.depotsDialogService.addDepots(event, this.avoidIds)
      .then((depotsIdsRes) => {
        const depotsIds = _.difference(depotsIdsRes, this.avoidIds);
        this._updateDepots(depotsIds, [this.branch.id]);
      })
  }

  onCreateDepot(event) {
    this.depotsDialogService.createDepot(event)
      .then((depotToCreate) => {
        depotToCreate.branchIds = [this.branch.id];
        this._createDepot(depotToCreate);
      })
  }

  onRemoveDepot(depot, event) {
    this.confirmDialogService.confirm('Remove Depot', 'Are you sure you want to remove this depot from branch?', event)
      .then(() => {
        if (_.get(depot, 'branchIds.length')) {
          let depotCopy = angular.copy(depot);
          depotCopy.branchIds = _.without(depot.branchIds, this.branch.id);
          this._removeDepot(depotCopy);
        }
      })
  }

  onReloadDepots() {
    this.doReload = false;
  }

  // ******************************
  //        Private methods
  // ******************************

  _createDepot(depot) {
    this.depotsService.createOne(depot)
      .then((createdDepot) => {
        this.avoidIds.push(depot.id);
        this.doReload = true;
      })
  }

  _updateDepots(depotsIds, branchIds) {
    this.depotsService.addBranchesToDepots(depotsIds, branchIds)
      .then((updatedDepots: DepotReferenceModel[]) => {
        _.forEach(updatedDepots, (depot) => {
          this.avoidIds.push(depot.id);
        })


        this.doReload = true;
      })
  }

  _removeDepot(depot) {
    this.depotsService.updateOne(depot.id, depot)
      .then((updatedDepot) => {
        this.avoidIds = _.filter(this.avoidIds, (idToAvoid) => {
          return idToAvoid !== depot.id;
        });
        this.doReload = true;
      })
  }

}

angular
  .module('bringoz.admin.branches')
  .component('branchesDepotsView', {
    bindings: {
      branch: '<'
    },
    template: require('./branches-depots-view.html').default,
    controller: BranchesDepotsViewCtrl
  });
